import { useEffect, useState } from "react";

export const LOCAL_KEY = "hide_auto_install_prompt";
const INSTALL_DELAY = 7000;

function isSafari() {
  return (
    /Safari/.test(navigator.userAgent) &&
    !/Chrome/.test(navigator.userAgent) &&
    !/CriOS/.test(navigator.userAgent)
  );
}

export default function useInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [autoOpen, setAutoOpen] = useState(false);
  const [isSafariBrowser, setIsSafariBrowser] = useState(false);
  const [hasPrompted, setHasPrompted] = useState(false);

  useEffect(() => {
    const hideAuto = localStorage.getItem(LOCAL_KEY);
    const safari = isSafari();
    setIsSafariBrowser(safari);
    console.log("isSafari: " + isSafari());
    if (!hideAuto) {
      const show = () => setTimeout(() => setAutoOpen(true), INSTALL_DELAY);

      if (!safari) {
        const handler = (e) => {
          console.log("✅ beforeinstallprompt fired");
          e.preventDefault();
          setDeferredPrompt(e);
          show();
        };

        window.addEventListener("beforeinstallprompt", handler);
        return () => window.removeEventListener("beforeinstallprompt", handler);
      }

      show(); // Safari
    }
  }, []);

  const dismissAutoPrompt = () => {
    setAutoOpen(false);
    localStorage.setItem(LOCAL_KEY, "true");
  };

  const installApp = async () => {
    if (isSafariBrowser) {
      dismissAutoPrompt();
      return;
    }

    if (deferredPrompt) {
      await deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome !== "dismissed") {
        dismissAutoPrompt();
        setHasPrompted(true);
      }
      setDeferredPrompt(null);
    }
  };

  return {
    isSafari: isSafariBrowser,
    autoOpen,
    dismissAutoPrompt,
    installApp,
    canManuallyInstall: isSafariBrowser || (!!deferredPrompt && !hasPrompted),
  };
}
